import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasSeenProcedureVideo: false,
  hasSeenProcedurePdf: false,
};

export const viewMediaSlice = createSlice({
  name: "viewMedia",
  initialState,
  reducers: {
    markVideoAsSeen(state) {
      state.hasSeenProcedureVideo = true;
    },
    markPdfAsSeen(state) {
      state.hasSeenProcedurePdf = true;
    },
    resetMediaSeen(state) {
      state.hasSeenProcedureVideo = false;
      state.hasSeenProcedurePdf = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { markVideoAsSeen, markPdfAsSeen, resetMediaSeen } =
  viewMediaSlice.actions;
